import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { MapPin, Building2, Globe, Star } from "lucide-react";

const KomikWarszawa = () => (
  <SeoPageLayout title="Komik i stand-up" titleAccent="Warszawa">
    <SeoSection title="Występy komediowe w Warszawie">
      <p>Warszawa to centrum biznesowe Polski, w którym odbywa się najwięcej eventów korporacyjnych, konferencji i gal firmowych. Oferujemy profesjonalne występy komediowe na terenie Warszawy i okolic. Nasi komicy znają warszawską scenę stand-upową i doskonale czują specyfikę stołecznej publiczności.</p>
    </SeoSection>

    <SeoSection title="Lokalizacje w Warszawie, w których występujemy">
      <SeoFeatureGrid features={[
        { icon: Building2, title: "Hotele i centra konferencyjne", description: "Marriott, Hilton, Intercontinental, Pałac Kultury" },
        { icon: MapPin, title: "Restauracje i sale bankietowe", description: "Najlepsze lokalizacje gastronomiczne w stolicy" },
        { icon: Star, title: "Biura i coworkingi", description: "Występy bezpośrednio w Waszej przestrzeni biurowej" },
        { icon: Globe, title: "Lokalizacje plenerowe", description: "Ogrody, tarasy, plaże nad Wisłą" },
      ]} />
    </SeoSection>

    <SeoSection title="Dlaczego warto zamówić komika w Warszawie?">
      <p>Warszawa oferuje ogromny wybór lokalizacji eventowych, co oznacza, że komik musi umieć dostosować się do różnych warunków - od kameralnej sali VIP po wielką scenę konferencyjną. Nasi artyści mają doświadczenie w występach we wszystkich tych formatach i znają najlepsze lokalizacje w mieście.</p>
    </SeoSection>

    <SeoSection title="Stand-up po angielsku w Warszawie">
      <p>Warszawa to międzynarodowe miasto, dlatego oferujemy również występy w języku angielskim. Jeśli w Twojej firmie pracują obcokrajowcy lub organizujesz event dla międzynarodowej publiczności - nasi komicy mogą wystąpić po angielsku, zachowując ten sam poziom humoru i profesjonalizmu.</p>
      <SeoHighlightBox icon={Globe}>
        Oferujemy również występy dwujęzyczne - idealny format dla firm z mieszanymi zespołami polsko-anglojęzycznymi.
      </SeoHighlightBox>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikWarszawa;
